
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.177 23.25h-10.5a1.5 1.5 0 0 1-1.5-1.5V8.25h13.5v13.5a1.5 1.5 0 0 1-1.5 1.5Zm-7.5-4.5v-6m4.5 6v-6M2.427 6.212l19.074-4.054M13.541.783l-4.4.935A1.5 1.5 0 0 0 7.984 3.5L8.3 4.965l7.336-1.56-.316-1.467A1.5 1.5 0 0 0 13.541.783Z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    